import { createServerOnlyFn } from "@tanstack/react-start";
import { handleCommunicationPreferencesUpdate } from "./profile-settings.server";

export const communicationPreferencesApiRoute = {
    server: {
        handlers: {
            PATCH: createServerOnlyFn(({ request }: { request: Request }) =>
                handleCommunicationPreferencesUpdate(request),
            ),
        },
    },
};
